import { BaseButtons, ICONE } from '@lucan/base-ui'
import Accesso from 'components/accesso/Accesso'
import ConfigManager from 'components/config/ConfigManager'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { PASS_HOME } from 'configuration/pass'
import { LINK_SERVIZI } from 'configuration/link'
import PassContenitore from './PassContenitore'

const CFG = PASS_HOME
const CFG_SERVIZI = LINK_SERVIZI

export default function PassHome() {
  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_PASS_HOME, ELENCHI.CFG_LINK_SERVIZI]}
      render={({ val }) =>
        <PassContenitore noHeader>
          <Accesso
            attivo={val(CFG_SERVIZI.PASS_ATTIVO)}
            spidAttivo={val(CFG.SPID_ATTIVO)}
            cieAttivo={val(CFG.CIE_ATTIVO)}
            chiaveRottaDopoAccesso={CHIAVI_ROUTES.PASS_LISTA}
          />

          <br/>
          <br/>
          <a
            href='/pdf/ManualePermessiStruttureRicettive.pdf'
            target='_blank'
            rel='noreferrer'
          >
            <BaseButtons.Custom
              testo='Manuale per Strutture Ricettive'
              iconaFine={ICONE.AIUTO}
              color='info'
            />
          </a>
        </PassContenitore>
      }
    />
  )
}